import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  setStep,
  addStepsData,
  prevStep,
} from "app/lib/store/slices/steps/loanTypesSteps";

import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";

interface FormData {
  vinNumber: number | string;
  licensePlateNumber: string | number;
}

const VinPlateNumber: React.FC = () => {
  const dispatch = useDispatch();
  const { stepsData } = useSelector((state: RootState) => state.loanTypesSteps);
  const { vehicleDetail, ...remainingData } = stepsData;
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    const { vinNumber, licensePlateNumber } = data;
    dispatch(
      addStepsData({
        ...remainingData,
        vehicleDetail: {
          ...vehicleDetail,
          vinNumber,
          licensePlateNumber,
        },
      })
    );
    dispatch(nextStep());
  };

  useEffect(() => {
    if (!vehicleDetail) return;
    reset({
      vinNumber: vehicleDetail?.vinNumber,
      licensePlateNumber: vehicleDetail?.licensePlateNumber,
    });
  }, [vehicleDetail, reset]);

  const handelPreview = () => {
    if (vehicleDetail?.isCarManuallyModel) {
      dispatch(setStep(3));
    } else if (vehicleDetail?.manuallyModel) {
      dispatch(setStep(4));
    } else {
      dispatch(prevStep());
    }
  };

  return (
    <>
      <ProgressBar progress={35} />
      <div className="w-full  sm:w-[70%] xl:w-[40%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="VIN & Plate Number" />
        <SubTitle title="Provide your vehicle’s VIN or license plate number to proceed" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <FormGroup>
            <InputField
              label="Vin number"
              name="vinNumber"
              control={control}
              type="number"
              required={true}
              placeholder="90128038491097294"
              error={errors.vinNumber?.message}
              className="flex-1"
            />
            <InputField
              label="License plate number"
              name="licensePlateNumber"
              control={control}
              type="text"
              required={true}
              placeholder="890211"
              error={errors.licensePlateNumber?.message}
              className="flex-1"
            />
          </FormGroup>

          <div className="flex justify-between my-10">
            <PreviousButtom onClick={handelPreview}>Previous</PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default VinPlateNumber;
